'use client'

import { TFAQCategory } from '@/entities/support'
import { Chip } from '@/shared/ui'

import { useFAQCategory } from '../../lib/category'

type Props = {
  categories: TFAQCategory[]
}

export const MobileFAQCategory = ({ categories }: Props) => {
  const { category, categoriesWithAll, handleCategoryChange } = useFAQCategory(
    categories,
    { replace: true },
  )

  return (
    <div className="my-8 flex flex-wrap gap-1.5">
      {categoriesWithAll.map(({ categoryCode, categoryName }) => (
        <div key={categoryCode}>
          <Chip
            size="medium"
            variant="solid"
            className="typo-label1"
            selected={category === categoryCode}
            onClick={() => {
              handleCategoryChange(categoryCode)
            }}
          >
            {categoryName}
          </Chip>
        </div>
      ))}
    </div>
  )
}
